<template>
  <div style="height: 100%;width: 100%;overflow: auto">
    <div>
      <el-form ref="formData" :model="busData" label-width="120px" :rules="rules" style="margin: 5px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="登录账号:" prop="user_name" required>
              <el-input v-model="busData.user_name" placeholder="请填写登录账号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="姓名:" prop="full_name" required>
              <el-input v-model="busData.full_name" placeholder="请填写姓名" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="初始密码:" prop="password" required>
              <el-input v-model="busData.password" placeholder="请填写初始密码" clearable show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="电子邮箱:" prop="email" required>
              <el-input v-model="busData.email" placeholder="请填写电子邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="手机:" prop="mobile">
              <el-input v-model="busData.mobile" placeholder="请填写手机" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="职位:" prop="position_id">
              <el-input v-model="busData.position_id" placeholder="请填写职位" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="22">
          <el-form-item label="部门" prop="department_ids" required>
            <el-cascader v-model="busData.department_ids" placeholder="请选择部门" :options="departmentList"
                         :show-all-levels="false" :props="{ value: 'id',label: 'name',multiple: true,checkStrictly: true,emitPath:false}"
                         style="width: 100%" clearable filterable>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="角色" prop="role_ids">
            <el-select v-model="busData.role_ids" placeholder="请选择角色" multiple required clearable>
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门负责人:" prop="is_head">
            <el-select v-model="busData.is_head" placeholder="确认是否是部门负责人" required>
              <el-option v-for="item in isHeadList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="照片:" >
            <kf-image-upload v-model="busData.photo" :limit="1" ></kf-image-upload>
          </el-form-item>
        </el-col>
        <div style="text-align: center;">
          <el-button size="default" type="primary" @click="addUser()">创建</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddUser",
  components: {},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      busData: {

      },
      roleList: [],
      departmentList: [],
      rules: {
        user_name: [
          { required: true, message: '请填写登录账号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'change' }
        ],
        full_name: [
          { required: true, message: '请填写姓名', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请填写电子邮箱', trigger: 'change' }
        ],
        role_ids: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        department_ids: [
          { required: true, message: '请选择部门', trigger: 'change'}
        ],
        is_head: [
          { required: true, message: '请确认是否是部门负责人', trigger: 'change' }
        ],
        departmentIds: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    isHeadList() {
      return this.$store.getters['core/getDictList']('bool');
    },
  },
  created() {
    this.getData();
    this.getRoleList();
    this.getDepartmentList();
  },

  methods: {
    async getData() {
      this.busData = this.parentData;
      this.busData.department_ids = this.parentData.department_ids.split(',');
      let params = this.busData;
      this.busData.role_ids = await this.$http('sysOrganizationService.getRoleIds', params);
    },

    async addUser() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let params = this.busData;
          this.$http('sysOrganizationService.addUser', params).then(() => {
            this.$message.success("提交成功");
            this.$fn.reloadTreeData();
            this.$fn.closeWindow();
          });
        } else {
          // 表单验证失败，提示用户
          console.log('表单验证失败，请检查输入');
          return false;
        }
      })
    },

    async getRoleList() {
      this.roleList = await this.$http('sysOrganizationService.getRoleList')
    },

    async getDepartmentList() {
      this.departmentList = await this.$http('sysOrganizationService.getDepartmentData')
    },

    async getRoleIds() {
      let params = this.busData;
      this.busData.role_ids = await this.$http('sysOrganizationService.getRoleIds', params);
    }

  },
//   beforeUnmount() {
//     // 当组件卸载时执行的方法
//     this.$fn.reloadTreeData();
//   }
}

</script>

<style scoped>

</style>